import Vue from 'vue';
import Router from 'vue-router';

import firebase from 'firebase/app';

import HomePage from '@/views/HomePage.vue';
import Calculator from '@/views/Calculator.vue';
import SummaryDashboard from '@/views/SummaryDashboard.vue';
import Register from '@/views/users/Register.vue';
import Login from '@/views/users/Login.vue';
import EditProfile from '@/views/users/EditProfile.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      props: true,
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: Calculator,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/summary-dashboard',
      name: 'summary-dashboard',
      component: SummaryDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/edit-profile',
      name: 'edit-profile',
      component: EditProfile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;